module.exports = __webpack_public_path__ + "static/media/LA-BG.e9e9ddbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/LA-BG.png
// module id = 257
// module chunks = 0